import classNames from "classnames";
import dayjs from "dayjs";

import style from "./style.module.scss";

import { ArrowLeft } from "../../assets/arrowLeft";
import patternLeft from "../../assets/buscaNotaPatternLeft.svg";
import patternRight from "../../assets/buscaNotaPatternRight.svg";
import { Promotion } from "../../assets/promotion";
import { Countdown } from "../../components/Countdown";

const mediaQueriesOptions = {
	phone: 768,
	tablet: {
		maxWidth: 1080,
		minWidth: 767,
	},
};

interface IProps {
	hideAfterScroll: boolean;
	onSubmit?: (e: React.MouseEvent) => void;
	endDateStr?: string;
	promotionTitleDesktop?: string;
	promotionTitleMobile?: string;
	promotionSubtitle?: string;
	backgroundColor: string;
	color: string;
	icon?: string | JSX.Element;
	backgroundColorButton?: string;
	colorButton?: string;
	backgroundColorPicture?: string;
	colorTime?: string;
	subColorTime?: string;
	theme?: string;
	titleColor?: string;
	backgroundColorTimer?: string;
	hasDifferentClockColor?: boolean;
	mobileClockColor?: string;
	isButtonVisible?: boolean;
}

export const PromotionBar = ({
	hideAfterScroll,
	onSubmit,
	endDateStr,
	promotionTitleMobile,
	promotionTitleDesktop,
	promotionSubtitle,
	backgroundColor,
	color,
	icon,
	backgroundColorButton,
	colorButton,
	backgroundColorPicture,
	theme,
	colorTime,
	subColorTime,
	titleColor,
	backgroundColorTimer,
	hasDifferentClockColor,
	mobileClockColor,
	isButtonVisible = true,
}: IProps): JSX.Element => {
	return (
		<header
			className={classNames(style.promotion, style.header, {
				[style.show]: !hideAfterScroll,
			})}
			style={{ backgroundColor, color }}
		>
			{theme === "buscaNotaEnem" && (
				<>
					<img className={style.patternLeft} loading="lazy" src={patternLeft} alt="" />
					<img className={style.patternRight} loading="lazy" src={patternRight} alt="" />
				</>
			)}
			<div className={style.container}>
				<div
					className={classNames(style.containerPromotion, {
						[style.buscaNotaEnem]: theme === "buscaNotaEnem" && !endDateStr,
						[style.buscaNotaEnemWithTimer]: theme === "buscaNotaEnem" && endDateStr,
					})}
				>
					<figure>
						<picture style={{ backgroundColor: backgroundColorPicture }}>{icon ?? <Promotion className={style.iconPromotion} />}</picture>
					</figure>

					{!promotionTitleMobile && (
						<p className={style.title}>
							Encontre as melhores bolsas com sua nota do ENEM! Acesse o{" "}
							<span className={classNames(style.title, style.yellow)}>Busca Nota Amigo Edu.</span>
						</p>
					)}
					{(promotionTitleMobile || promotionTitleDesktop) &&
					typeof window !== "undefined" &&
					window.innerWidth <= mediaQueriesOptions.phone ? (
						<div className={style.labels}>
							<p
								className={classNames(style.promotionTitle, {
									[style.blackFriday]: theme === "blackFriday",
								})}
								style={getTitleColor()}
							>
								{promotionTitleMobile}
							</p>
							<span>{promotionSubtitle ?? ""}</span>
						</div>
					) : (
						<div className={style.labels}>
							<p
								className={classNames(style.promotionTitle, {
									[style.blackFriday]: theme === "blackFriday",
								})}
								style={getTitleColor()}
							>
								{promotionTitleDesktop}
							</p>
							<span>{promotionSubtitle ?? ""}</span>
						</div>
					)}
					{endDateStr && (
						<Countdown
							countdown={dayjs(endDateStr).diff(new Date(), "second")}
							color={colorTime}
							subColor={subColorTime}
							backgroundColor={backgroundColorTimer}
							hasDifferentClockColor={hasDifferentClockColor}
							mobileClockColor={mobileClockColor}
						/>
					)}
					{onSubmit && isButtonVisible && (
						<div
							className={classNames(style.buttonContainer, {
								[style.buscaNotaEnemBtn]: theme === "buscaNotaEnem",
							})}
						>
							<a
								onClick={onSubmit}
								type="submit"
								href={"#"}
								style={{
									backgroundColor: backgroundColorButton,
									color: colorButton,
								}}
							>
								<span>{theme === "buscaNotaEnem" ? "Ir para o Busca Nota" : "ver ofertas"}</span>
								<ArrowLeft className={style.arrowRight} />
							</a>
						</div>
					)}
				</div>
			</div>
		</header>
	);

	function getTitleColor(): React.CSSProperties | undefined {
		return titleColor ? { color: titleColor } : undefined;
	}
};
